<template>
  <div>
    <div class="identityAndAccessManagementResource-title">
      <div>{{ $t("RAM.AWS.IdentityAndAccessManagement.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:identityAndAccessManagementResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:identityAndAccessManagementResource:export'
          ]"
          :loading="modal_loading"
          @click="iamExport"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="identityAndAccessManagementResource-top">
      <identity-and-access-management-resource-search
        ref="iamSearch"
      ></identity-and-access-management-resource-search>
    </div>
    <table-identity-and-access-management-resource></table-identity-and-access-management-resource>
  </div>
</template>

<script>
import IdentityAndAccessManagementResourceSearch from "../iam/IdentityAndAccessManagementResourceSearch";
import TableIdentityAndAccessManagementResource from "../iam/TableIdentityAndAccessManagementResource";

export default {
  name: "IdentityAndAccessManagementResource",
  components: {
    IdentityAndAccessManagementResourceSearch,
    TableIdentityAndAccessManagementResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: "",
      iamUserName: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.iamSearch.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 14
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    iamExport: function() {
      // Get export request parameters
      this.iamUserName = this.$refs.iamSearch.iamUserName;
      this.companyId = this.$refs.iamSearch.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // Call export api
      this.$api.resourceManagement
        .exportAWSIam({
          iamUserName: this.iamUserName,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "AWS_IAM.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.identityAndAccessManagementResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.identityAndAccessManagementResource-title > div:nth-child(1) {
  float: left;
}
.identityAndAccessManagementResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.identityAndAccessManagementResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/iam/IdentityAndAccessManagementResource.vue